// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file ibc/core/channel/v1/query.proto (package ibc.core.channel.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Any, Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Channel, IdentifiedChannel, PacketState } from "./channel_pb.js";
import { Height, IdentifiedClientState } from "../../client/v1/client_pb.js";
import { PageRequest, PageResponse } from "../../../../cosmos/base/query/v1beta1/pagination_pb.js";
/**
 * QueryChannelRequest is the request type for the Query/Channel RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryChannelRequest
 */
export class QueryChannelRequest extends Message {
    /**
     * port unique identifier
     *
     * @generated from field: string port_id = 1;
     */
    portId = "";
    /**
     * channel unique identifier
     *
     * @generated from field: string channel_id = 2;
     */
    channelId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryChannelRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new QueryChannelRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryChannelRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryChannelRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryChannelRequest, a, b);
    }
}
/**
 * QueryChannelResponse is the response type for the Query/Channel RPC method.
 * Besides the Channel end, it includes a proof and the height from which the
 * proof was retrieved.
 *
 * @generated from message ibc.core.channel.v1.QueryChannelResponse
 */
export class QueryChannelResponse extends Message {
    /**
     * channel associated with the request identifiers
     *
     * @generated from field: ibc.core.channel.v1.Channel channel = 1;
     */
    channel;
    /**
     * merkle proof of existence
     *
     * @generated from field: bytes proof = 2;
     */
    proof = new Uint8Array(0);
    /**
     * height at which the proof was retrieved
     *
     * @generated from field: ibc.core.client.v1.Height proof_height = 3;
     */
    proofHeight;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryChannelResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "channel", kind: "message", T: Channel },
        { no: 2, name: "proof", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "proof_height", kind: "message", T: Height },
    ]);
    static fromBinary(bytes, options) {
        return new QueryChannelResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryChannelResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryChannelResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryChannelResponse, a, b);
    }
}
/**
 * QueryChannelsRequest is the request type for the Query/Channels RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryChannelsRequest
 */
export class QueryChannelsRequest extends Message {
    /**
     * pagination request
     *
     * @generated from field: cosmos.base.query.v1beta1.PageRequest pagination = 1;
     */
    pagination;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryChannelsRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "pagination", kind: "message", T: PageRequest },
    ]);
    static fromBinary(bytes, options) {
        return new QueryChannelsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryChannelsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryChannelsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryChannelsRequest, a, b);
    }
}
/**
 * QueryChannelsResponse is the response type for the Query/Channels RPC method.
 *
 * @generated from message ibc.core.channel.v1.QueryChannelsResponse
 */
export class QueryChannelsResponse extends Message {
    /**
     * list of stored channels of the chain.
     *
     * @generated from field: repeated ibc.core.channel.v1.IdentifiedChannel channels = 1;
     */
    channels = [];
    /**
     * pagination response
     *
     * @generated from field: cosmos.base.query.v1beta1.PageResponse pagination = 2;
     */
    pagination;
    /**
     * query block height
     *
     * @generated from field: ibc.core.client.v1.Height height = 3;
     */
    height;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryChannelsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "channels", kind: "message", T: IdentifiedChannel, repeated: true },
        { no: 2, name: "pagination", kind: "message", T: PageResponse },
        { no: 3, name: "height", kind: "message", T: Height },
    ]);
    static fromBinary(bytes, options) {
        return new QueryChannelsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryChannelsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryChannelsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryChannelsResponse, a, b);
    }
}
/**
 * QueryConnectionChannelsRequest is the request type for the
 * Query/QueryConnectionChannels RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryConnectionChannelsRequest
 */
export class QueryConnectionChannelsRequest extends Message {
    /**
     * connection unique identifier
     *
     * @generated from field: string connection = 1;
     */
    connection = "";
    /**
     * pagination request
     *
     * @generated from field: cosmos.base.query.v1beta1.PageRequest pagination = 2;
     */
    pagination;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryConnectionChannelsRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "connection", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "pagination", kind: "message", T: PageRequest },
    ]);
    static fromBinary(bytes, options) {
        return new QueryConnectionChannelsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryConnectionChannelsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryConnectionChannelsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryConnectionChannelsRequest, a, b);
    }
}
/**
 * QueryConnectionChannelsResponse is the Response type for the
 * Query/QueryConnectionChannels RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryConnectionChannelsResponse
 */
export class QueryConnectionChannelsResponse extends Message {
    /**
     * list of channels associated with a connection.
     *
     * @generated from field: repeated ibc.core.channel.v1.IdentifiedChannel channels = 1;
     */
    channels = [];
    /**
     * pagination response
     *
     * @generated from field: cosmos.base.query.v1beta1.PageResponse pagination = 2;
     */
    pagination;
    /**
     * query block height
     *
     * @generated from field: ibc.core.client.v1.Height height = 3;
     */
    height;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryConnectionChannelsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "channels", kind: "message", T: IdentifiedChannel, repeated: true },
        { no: 2, name: "pagination", kind: "message", T: PageResponse },
        { no: 3, name: "height", kind: "message", T: Height },
    ]);
    static fromBinary(bytes, options) {
        return new QueryConnectionChannelsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryConnectionChannelsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryConnectionChannelsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryConnectionChannelsResponse, a, b);
    }
}
/**
 * QueryChannelClientStateRequest is the request type for the Query/ClientState
 * RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryChannelClientStateRequest
 */
export class QueryChannelClientStateRequest extends Message {
    /**
     * port unique identifier
     *
     * @generated from field: string port_id = 1;
     */
    portId = "";
    /**
     * channel unique identifier
     *
     * @generated from field: string channel_id = 2;
     */
    channelId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryChannelClientStateRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new QueryChannelClientStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryChannelClientStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryChannelClientStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryChannelClientStateRequest, a, b);
    }
}
/**
 * QueryChannelClientStateResponse is the Response type for the
 * Query/QueryChannelClientState RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryChannelClientStateResponse
 */
export class QueryChannelClientStateResponse extends Message {
    /**
     * client state associated with the channel
     *
     * @generated from field: ibc.core.client.v1.IdentifiedClientState identified_client_state = 1;
     */
    identifiedClientState;
    /**
     * merkle proof of existence
     *
     * @generated from field: bytes proof = 2;
     */
    proof = new Uint8Array(0);
    /**
     * height at which the proof was retrieved
     *
     * @generated from field: ibc.core.client.v1.Height proof_height = 3;
     */
    proofHeight;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryChannelClientStateResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "identified_client_state", kind: "message", T: IdentifiedClientState },
        { no: 2, name: "proof", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "proof_height", kind: "message", T: Height },
    ]);
    static fromBinary(bytes, options) {
        return new QueryChannelClientStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryChannelClientStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryChannelClientStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryChannelClientStateResponse, a, b);
    }
}
/**
 * QueryChannelConsensusStateRequest is the request type for the
 * Query/ConsensusState RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryChannelConsensusStateRequest
 */
export class QueryChannelConsensusStateRequest extends Message {
    /**
     * port unique identifier
     *
     * @generated from field: string port_id = 1;
     */
    portId = "";
    /**
     * channel unique identifier
     *
     * @generated from field: string channel_id = 2;
     */
    channelId = "";
    /**
     * revision number of the consensus state
     *
     * @generated from field: uint64 revision_number = 3;
     */
    revisionNumber = protoInt64.zero;
    /**
     * revision height of the consensus state
     *
     * @generated from field: uint64 revision_height = 4;
     */
    revisionHeight = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryChannelConsensusStateRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "revision_number", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "revision_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new QueryChannelConsensusStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryChannelConsensusStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryChannelConsensusStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryChannelConsensusStateRequest, a, b);
    }
}
/**
 * QueryChannelClientStateResponse is the Response type for the
 * Query/QueryChannelClientState RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryChannelConsensusStateResponse
 */
export class QueryChannelConsensusStateResponse extends Message {
    /**
     * consensus state associated with the channel
     *
     * @generated from field: google.protobuf.Any consensus_state = 1;
     */
    consensusState;
    /**
     * client ID associated with the consensus state
     *
     * @generated from field: string client_id = 2;
     */
    clientId = "";
    /**
     * merkle proof of existence
     *
     * @generated from field: bytes proof = 3;
     */
    proof = new Uint8Array(0);
    /**
     * height at which the proof was retrieved
     *
     * @generated from field: ibc.core.client.v1.Height proof_height = 4;
     */
    proofHeight;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryChannelConsensusStateResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "consensus_state", kind: "message", T: Any },
        { no: 2, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "proof", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 4, name: "proof_height", kind: "message", T: Height },
    ]);
    static fromBinary(bytes, options) {
        return new QueryChannelConsensusStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryChannelConsensusStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryChannelConsensusStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryChannelConsensusStateResponse, a, b);
    }
}
/**
 * QueryPacketCommitmentRequest is the request type for the
 * Query/PacketCommitment RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryPacketCommitmentRequest
 */
export class QueryPacketCommitmentRequest extends Message {
    /**
     * port unique identifier
     *
     * @generated from field: string port_id = 1;
     */
    portId = "";
    /**
     * channel unique identifier
     *
     * @generated from field: string channel_id = 2;
     */
    channelId = "";
    /**
     * packet sequence
     *
     * @generated from field: uint64 sequence = 3;
     */
    sequence = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryPacketCommitmentRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new QueryPacketCommitmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryPacketCommitmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryPacketCommitmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryPacketCommitmentRequest, a, b);
    }
}
/**
 * QueryPacketCommitmentResponse defines the client query response for a packet
 * which also includes a proof and the height from which the proof was
 * retrieved
 *
 * @generated from message ibc.core.channel.v1.QueryPacketCommitmentResponse
 */
export class QueryPacketCommitmentResponse extends Message {
    /**
     * packet associated with the request fields
     *
     * @generated from field: bytes commitment = 1;
     */
    commitment = new Uint8Array(0);
    /**
     * merkle proof of existence
     *
     * @generated from field: bytes proof = 2;
     */
    proof = new Uint8Array(0);
    /**
     * height at which the proof was retrieved
     *
     * @generated from field: ibc.core.client.v1.Height proof_height = 3;
     */
    proofHeight;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryPacketCommitmentResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "commitment", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "proof", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "proof_height", kind: "message", T: Height },
    ]);
    static fromBinary(bytes, options) {
        return new QueryPacketCommitmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryPacketCommitmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryPacketCommitmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryPacketCommitmentResponse, a, b);
    }
}
/**
 * QueryPacketCommitmentsRequest is the request type for the
 * Query/QueryPacketCommitments RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryPacketCommitmentsRequest
 */
export class QueryPacketCommitmentsRequest extends Message {
    /**
     * port unique identifier
     *
     * @generated from field: string port_id = 1;
     */
    portId = "";
    /**
     * channel unique identifier
     *
     * @generated from field: string channel_id = 2;
     */
    channelId = "";
    /**
     * pagination request
     *
     * @generated from field: cosmos.base.query.v1beta1.PageRequest pagination = 3;
     */
    pagination;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryPacketCommitmentsRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "pagination", kind: "message", T: PageRequest },
    ]);
    static fromBinary(bytes, options) {
        return new QueryPacketCommitmentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryPacketCommitmentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryPacketCommitmentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryPacketCommitmentsRequest, a, b);
    }
}
/**
 * QueryPacketCommitmentsResponse is the request type for the
 * Query/QueryPacketCommitments RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryPacketCommitmentsResponse
 */
export class QueryPacketCommitmentsResponse extends Message {
    /**
     * @generated from field: repeated ibc.core.channel.v1.PacketState commitments = 1;
     */
    commitments = [];
    /**
     * pagination response
     *
     * @generated from field: cosmos.base.query.v1beta1.PageResponse pagination = 2;
     */
    pagination;
    /**
     * query block height
     *
     * @generated from field: ibc.core.client.v1.Height height = 3;
     */
    height;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryPacketCommitmentsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "commitments", kind: "message", T: PacketState, repeated: true },
        { no: 2, name: "pagination", kind: "message", T: PageResponse },
        { no: 3, name: "height", kind: "message", T: Height },
    ]);
    static fromBinary(bytes, options) {
        return new QueryPacketCommitmentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryPacketCommitmentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryPacketCommitmentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryPacketCommitmentsResponse, a, b);
    }
}
/**
 * QueryPacketReceiptRequest is the request type for the
 * Query/PacketReceipt RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryPacketReceiptRequest
 */
export class QueryPacketReceiptRequest extends Message {
    /**
     * port unique identifier
     *
     * @generated from field: string port_id = 1;
     */
    portId = "";
    /**
     * channel unique identifier
     *
     * @generated from field: string channel_id = 2;
     */
    channelId = "";
    /**
     * packet sequence
     *
     * @generated from field: uint64 sequence = 3;
     */
    sequence = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryPacketReceiptRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new QueryPacketReceiptRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryPacketReceiptRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryPacketReceiptRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryPacketReceiptRequest, a, b);
    }
}
/**
 * QueryPacketReceiptResponse defines the client query response for a packet
 * receipt which also includes a proof, and the height from which the proof was
 * retrieved
 *
 * @generated from message ibc.core.channel.v1.QueryPacketReceiptResponse
 */
export class QueryPacketReceiptResponse extends Message {
    /**
     * success flag for if receipt exists
     *
     * @generated from field: bool received = 2;
     */
    received = false;
    /**
     * merkle proof of existence
     *
     * @generated from field: bytes proof = 3;
     */
    proof = new Uint8Array(0);
    /**
     * height at which the proof was retrieved
     *
     * @generated from field: ibc.core.client.v1.Height proof_height = 4;
     */
    proofHeight;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryPacketReceiptResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "received", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 3, name: "proof", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 4, name: "proof_height", kind: "message", T: Height },
    ]);
    static fromBinary(bytes, options) {
        return new QueryPacketReceiptResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryPacketReceiptResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryPacketReceiptResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryPacketReceiptResponse, a, b);
    }
}
/**
 * QueryPacketAcknowledgementRequest is the request type for the
 * Query/PacketAcknowledgement RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryPacketAcknowledgementRequest
 */
export class QueryPacketAcknowledgementRequest extends Message {
    /**
     * port unique identifier
     *
     * @generated from field: string port_id = 1;
     */
    portId = "";
    /**
     * channel unique identifier
     *
     * @generated from field: string channel_id = 2;
     */
    channelId = "";
    /**
     * packet sequence
     *
     * @generated from field: uint64 sequence = 3;
     */
    sequence = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryPacketAcknowledgementRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new QueryPacketAcknowledgementRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryPacketAcknowledgementRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryPacketAcknowledgementRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryPacketAcknowledgementRequest, a, b);
    }
}
/**
 * QueryPacketAcknowledgementResponse defines the client query response for a
 * packet which also includes a proof and the height from which the
 * proof was retrieved
 *
 * @generated from message ibc.core.channel.v1.QueryPacketAcknowledgementResponse
 */
export class QueryPacketAcknowledgementResponse extends Message {
    /**
     * packet associated with the request fields
     *
     * @generated from field: bytes acknowledgement = 1;
     */
    acknowledgement = new Uint8Array(0);
    /**
     * merkle proof of existence
     *
     * @generated from field: bytes proof = 2;
     */
    proof = new Uint8Array(0);
    /**
     * height at which the proof was retrieved
     *
     * @generated from field: ibc.core.client.v1.Height proof_height = 3;
     */
    proofHeight;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryPacketAcknowledgementResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "acknowledgement", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "proof", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "proof_height", kind: "message", T: Height },
    ]);
    static fromBinary(bytes, options) {
        return new QueryPacketAcknowledgementResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryPacketAcknowledgementResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryPacketAcknowledgementResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryPacketAcknowledgementResponse, a, b);
    }
}
/**
 * QueryPacketAcknowledgementsRequest is the request type for the
 * Query/QueryPacketCommitments RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryPacketAcknowledgementsRequest
 */
export class QueryPacketAcknowledgementsRequest extends Message {
    /**
     * port unique identifier
     *
     * @generated from field: string port_id = 1;
     */
    portId = "";
    /**
     * channel unique identifier
     *
     * @generated from field: string channel_id = 2;
     */
    channelId = "";
    /**
     * pagination request
     *
     * @generated from field: cosmos.base.query.v1beta1.PageRequest pagination = 3;
     */
    pagination;
    /**
     * list of packet sequences
     *
     * @generated from field: repeated uint64 packet_commitment_sequences = 4;
     */
    packetCommitmentSequences = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryPacketAcknowledgementsRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "pagination", kind: "message", T: PageRequest },
        { no: 4, name: "packet_commitment_sequences", kind: "scalar", T: 4 /* ScalarType.UINT64 */, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new QueryPacketAcknowledgementsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryPacketAcknowledgementsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryPacketAcknowledgementsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryPacketAcknowledgementsRequest, a, b);
    }
}
/**
 * QueryPacketAcknowledgemetsResponse is the request type for the
 * Query/QueryPacketAcknowledgements RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryPacketAcknowledgementsResponse
 */
export class QueryPacketAcknowledgementsResponse extends Message {
    /**
     * @generated from field: repeated ibc.core.channel.v1.PacketState acknowledgements = 1;
     */
    acknowledgements = [];
    /**
     * pagination response
     *
     * @generated from field: cosmos.base.query.v1beta1.PageResponse pagination = 2;
     */
    pagination;
    /**
     * query block height
     *
     * @generated from field: ibc.core.client.v1.Height height = 3;
     */
    height;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryPacketAcknowledgementsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "acknowledgements", kind: "message", T: PacketState, repeated: true },
        { no: 2, name: "pagination", kind: "message", T: PageResponse },
        { no: 3, name: "height", kind: "message", T: Height },
    ]);
    static fromBinary(bytes, options) {
        return new QueryPacketAcknowledgementsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryPacketAcknowledgementsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryPacketAcknowledgementsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryPacketAcknowledgementsResponse, a, b);
    }
}
/**
 * QueryUnreceivedPacketsRequest is the request type for the
 * Query/UnreceivedPackets RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryUnreceivedPacketsRequest
 */
export class QueryUnreceivedPacketsRequest extends Message {
    /**
     * port unique identifier
     *
     * @generated from field: string port_id = 1;
     */
    portId = "";
    /**
     * channel unique identifier
     *
     * @generated from field: string channel_id = 2;
     */
    channelId = "";
    /**
     * list of packet sequences
     *
     * @generated from field: repeated uint64 packet_commitment_sequences = 3;
     */
    packetCommitmentSequences = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryUnreceivedPacketsRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "packet_commitment_sequences", kind: "scalar", T: 4 /* ScalarType.UINT64 */, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new QueryUnreceivedPacketsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryUnreceivedPacketsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryUnreceivedPacketsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryUnreceivedPacketsRequest, a, b);
    }
}
/**
 * QueryUnreceivedPacketsResponse is the response type for the
 * Query/UnreceivedPacketCommitments RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryUnreceivedPacketsResponse
 */
export class QueryUnreceivedPacketsResponse extends Message {
    /**
     * list of unreceived packet sequences
     *
     * @generated from field: repeated uint64 sequences = 1;
     */
    sequences = [];
    /**
     * query block height
     *
     * @generated from field: ibc.core.client.v1.Height height = 2;
     */
    height;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryUnreceivedPacketsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "sequences", kind: "scalar", T: 4 /* ScalarType.UINT64 */, repeated: true },
        { no: 2, name: "height", kind: "message", T: Height },
    ]);
    static fromBinary(bytes, options) {
        return new QueryUnreceivedPacketsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryUnreceivedPacketsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryUnreceivedPacketsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryUnreceivedPacketsResponse, a, b);
    }
}
/**
 * QueryUnreceivedAcks is the request type for the
 * Query/UnreceivedAcks RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryUnreceivedAcksRequest
 */
export class QueryUnreceivedAcksRequest extends Message {
    /**
     * port unique identifier
     *
     * @generated from field: string port_id = 1;
     */
    portId = "";
    /**
     * channel unique identifier
     *
     * @generated from field: string channel_id = 2;
     */
    channelId = "";
    /**
     * list of acknowledgement sequences
     *
     * @generated from field: repeated uint64 packet_ack_sequences = 3;
     */
    packetAckSequences = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryUnreceivedAcksRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "packet_ack_sequences", kind: "scalar", T: 4 /* ScalarType.UINT64 */, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new QueryUnreceivedAcksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryUnreceivedAcksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryUnreceivedAcksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryUnreceivedAcksRequest, a, b);
    }
}
/**
 * QueryUnreceivedAcksResponse is the response type for the
 * Query/UnreceivedAcks RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryUnreceivedAcksResponse
 */
export class QueryUnreceivedAcksResponse extends Message {
    /**
     * list of unreceived acknowledgement sequences
     *
     * @generated from field: repeated uint64 sequences = 1;
     */
    sequences = [];
    /**
     * query block height
     *
     * @generated from field: ibc.core.client.v1.Height height = 2;
     */
    height;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryUnreceivedAcksResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "sequences", kind: "scalar", T: 4 /* ScalarType.UINT64 */, repeated: true },
        { no: 2, name: "height", kind: "message", T: Height },
    ]);
    static fromBinary(bytes, options) {
        return new QueryUnreceivedAcksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryUnreceivedAcksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryUnreceivedAcksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryUnreceivedAcksResponse, a, b);
    }
}
/**
 * QueryNextSequenceReceiveRequest is the request type for the
 * Query/QueryNextSequenceReceiveRequest RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryNextSequenceReceiveRequest
 */
export class QueryNextSequenceReceiveRequest extends Message {
    /**
     * port unique identifier
     *
     * @generated from field: string port_id = 1;
     */
    portId = "";
    /**
     * channel unique identifier
     *
     * @generated from field: string channel_id = 2;
     */
    channelId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryNextSequenceReceiveRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new QueryNextSequenceReceiveRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryNextSequenceReceiveRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryNextSequenceReceiveRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryNextSequenceReceiveRequest, a, b);
    }
}
/**
 * QuerySequenceResponse is the request type for the
 * Query/QueryNextSequenceReceiveResponse RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryNextSequenceReceiveResponse
 */
export class QueryNextSequenceReceiveResponse extends Message {
    /**
     * next sequence receive number
     *
     * @generated from field: uint64 next_sequence_receive = 1;
     */
    nextSequenceReceive = protoInt64.zero;
    /**
     * merkle proof of existence
     *
     * @generated from field: bytes proof = 2;
     */
    proof = new Uint8Array(0);
    /**
     * height at which the proof was retrieved
     *
     * @generated from field: ibc.core.client.v1.Height proof_height = 3;
     */
    proofHeight;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryNextSequenceReceiveResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "next_sequence_receive", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "proof", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "proof_height", kind: "message", T: Height },
    ]);
    static fromBinary(bytes, options) {
        return new QueryNextSequenceReceiveResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryNextSequenceReceiveResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryNextSequenceReceiveResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryNextSequenceReceiveResponse, a, b);
    }
}
/**
 * QueryNextSequenceSendRequest is the request type for the
 * Query/QueryNextSequenceSend RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryNextSequenceSendRequest
 */
export class QueryNextSequenceSendRequest extends Message {
    /**
     * port unique identifier
     *
     * @generated from field: string port_id = 1;
     */
    portId = "";
    /**
     * channel unique identifier
     *
     * @generated from field: string channel_id = 2;
     */
    channelId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryNextSequenceSendRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "port_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new QueryNextSequenceSendRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryNextSequenceSendRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryNextSequenceSendRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryNextSequenceSendRequest, a, b);
    }
}
/**
 * QueryNextSequenceSendResponse is the request type for the
 * Query/QueryNextSequenceSend RPC method
 *
 * @generated from message ibc.core.channel.v1.QueryNextSequenceSendResponse
 */
export class QueryNextSequenceSendResponse extends Message {
    /**
     * next sequence send number
     *
     * @generated from field: uint64 next_sequence_send = 1;
     */
    nextSequenceSend = protoInt64.zero;
    /**
     * merkle proof of existence
     *
     * @generated from field: bytes proof = 2;
     */
    proof = new Uint8Array(0);
    /**
     * height at which the proof was retrieved
     *
     * @generated from field: ibc.core.client.v1.Height proof_height = 3;
     */
    proofHeight;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "ibc.core.channel.v1.QueryNextSequenceSendResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "next_sequence_send", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "proof", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "proof_height", kind: "message", T: Height },
    ]);
    static fromBinary(bytes, options) {
        return new QueryNextSequenceSendResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryNextSequenceSendResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryNextSequenceSendResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryNextSequenceSendResponse, a, b);
    }
}
